import React from "react"
import PropTypes from "prop-types"

import { SortablePicker } from "ui"
import WithObject from "data/wrappers/WithObject"

class SortableFieldsPicker extends React.Component {
    render() {
        return (
            <WithObject loading="LOADING" objectId={this.props.objectId}>
                {({ object }) => {
                    return (
                        <SortablePicker
                            onChange={this.props.onChange}
                            fields={object.fields}
                            values={this.props.value || []}
                        />
                    )
                }}
            </WithObject>
        )
    }
}

SortableFieldsPicker.propTypes = {}

export default SortableFieldsPicker



// WEBPACK FOOTER //
// ./src/features/studio/components/SortableFieldsPicker.js